export const PolaroidCard = ({ src, alt }: { src: string; alt: string }) => (
  <div className="bg-white rounded-sm shadow-xl p-3 w-[180px] sm:w-[210px] md:w-[230px]">
    <div className="overflow-hidden rounded-sm h-[200px] sm:h-[230px] md:h-[250px]">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="w-full h-full object-cover"
      />
    </div>
    {/* extra white space at bottom like a Polaroid */}
    <div className="h-6 sm:h-8" />
  </div>
);
